<div class="container">
  <div class="header">
    <div class="header-left">
      <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="" #filter>
      </mat-form-field>
    </div>

    <div class="header-right">
      <span>{{ this.timeSinceLastRefresh }} since last refresh</span>
    </div>
  </div>

  <div class="application-table">
    <mat-table [dataSource]="source" matSort matSortActive="applicationID" matSortDirection="desc">
      <ng-container [matColumnDef]="def.field" *ngFor="let def of colDefs">
        <mat-header-cell *matHeaderCellDef mat-sort-header [sortActionDescription]="'Sort by ' + def.header">
          <div class="table-header">{{ def.header }}</div>
        </mat-header-cell>

        <mat-cell *matCellDef="let element">
          <input readonly
              *ngIf="def.format == undefined"
              [value]="element[def.field]">
          <input readonly
              *ngIf="def.format == 'titlecase'"
              [value]="element[def.field] | titlecase">
          <input  readonly
              *ngIf="def.format == 'currency'"
              [value]="element[def.field] | currency">
          <input  readonly
              *ngIf="def.format == 'percentage'"
              [value]="element[def.field] ? element[def.field] + '%' : '' ">
          <input  readonly
              *ngIf="def.format == 'date'"
              [value]="element[def.field] | date: 'mediumDate'">
          <input  readonly
              *ngIf="def.format == 'phone'"
              [value]="element[def.field] | phone">
          <input readonly [class]="'status status-' + element[def.field] | lowercase"
              *ngIf="def.format == 'status'"
              [value]="element[def.field] | phone">
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="this.displayedCols"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedCols;"></mat-row>

      <!-- theoretically should work but angular doesn't like it
      <mat-row *matNoDataRow>
        <mat-cell [attr.colspan]="colDefs.length">No data matching the filter "{{filter.value}}"</mat-cell>
      </mat-row>
      -->
    </mat-table>
  </div>

  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of applications"></mat-paginator>
</div>